<div class="search-row">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchInputValue" (keyup)="filterSearchReward()">
  </mat-form-field>
</div>

<div class="lists">
  <div class="list">
    <div class="list-header">
      <h2>{{ currentSegment === 'export' ? 'All rewards' : 'Imported rewards' }}</h2>
      <button *ngIf="currentSegment === 'export'" mat-stroked-button color="primary" (click)="exportAll()">Export all</button>
    </div>
    <p *ngIf="filteredRewards.length <= 0">No rewards to show...</p>
    <mat-selection-list *ngIf="filteredRewards.length > 0">
      <mat-list-option *ngFor="let reward of filteredRewards" (click)="checkboxToggleReward(reward)">
        {{reward.name}}
      </mat-list-option>
    </mat-selection-list>
  </div>

  <div class="list">
    <h2>{{ currentSegment === 'export' ? 'Selected rewards' : 'Removed rewards' }}</h2>
    <p *ngIf="selectedRewards.length <= 0">No selected rewards to show...</p>
    <mat-selection-list *ngIf="selectedRewards.length > 0">
      <mat-list-option *ngFor="let reward of selectedRewards" (click)="checkboxToggleReward(reward)">
        {{reward.name}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="actions">
  <button mat-raised-button color="primary" (click)="sendSelectedRewards()">Save</button>
</div>
